<template>
  <div class="all_part">
    <div class="head">
      <div class="Logo">
        <img src="../assets/Main_menu_img/main_menu_title_Logo.png" alt=""/>
      </div>
    </div>
    <div class="all_input_control">
      <div class="all_control" v-if="this.$route.params.userId==1">
        <div class="all_control_input_button">
          <div class="Type_title">
            <span>竞品关联信息</span>
          </div>
          <div class="type_selection">
            <div>
              <span>关联类型</span>
            </div>
            <div>
              <el-radio-group v-model="selectC">
                <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)"
                          :disabled="opt.id!=jinxuan">
                  {{ opt.value }}
                </el-radio>
              </el-radio-group>
            </div>
          </div>
          <div>
            <div class="title_input_button">
              <div class="titles">
                <span>关联企业</span>
              </div>
              <div class="all_input">
                <el-select v-model="companyChoice" filterable placeholder="请选择" style="width: 200px" value-key="id"
                           clearable @change="change('a', companyChoice)">
                  <el-option
                      v-for="item in companyTable"
                      :key="item.id"
                      :label="item.enterprise"
                      :value="{id:item.id, companyName:item.enterprise}"
                  >
                  </el-option>
                </el-select>
              </div>
              <div>
                <el-button @click="Pan_add_companyTable">新增</el-button>
              </div>
            </div>

          </div>
          <div>
            <div class="title_input_button">
              <div class="titles">
                <span>关联人员</span>
              </div>
              <div class="all_input">
                <el-select v-model="staff_name_select" filterable placeholder="请选择" style="width: 200px"
                >
                  <el-option
                      v-for="item in companyStaffTable"
                      :key="item.value"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div>
                <el-button @click="Pan_add_staff()">新增</el-button>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="all_control" v-if=" this.$route.params.userId==1">
        <div class="all_control_input_button">
          <div class="Type_title">
            <span>FAB用户</span>
          </div>
          <div class="type_selection">
            <div>
              <span>关联类型</span>
            </div>
            <el-radio-group v-model="selectFAB">
              <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)"
                        :disabled="opt.id!=jinxuan3">
                {{ opt.value }}
              </el-radio>
            </el-radio-group>
          </div>
          <div>
            <div class="title_input_button">
              <div class="titles">
                <span>关联企业</span>
              </div>
              <div class="all_input">
                <el-select v-model="FABcompanChoice" filterable placeholder="请选择" style="width: 200px" value-key="id"
                           clearable @change="change('b', FABcompanChoice)">
                  <el-option
                      v-for="item in FABcompanyTable"
                      :key="item.id"
                      :label="item.enterprise"
                      :value="{id:item.id, companyName:item.enterprise}"
                  >
                  </el-option>
                </el-select>

              </div>
              <div>
                <el-button @click="add_companyTable=2">新增</el-button>
              </div>
            </div>

          </div>
          <div>
            <div class="title_input_button">
              <div class="titles">
                <span>关联人员</span>
              </div>
              <div class="all_input">
                <el-select v-model="FABstaff_name_select" filterable placeholder="请选择" style="width: 200px">
                  <el-option
                      v-for="item in FABcompanyStaffTable"
                      :key="item.value"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div>
                <el-button @click="Pan_add_FABstaff">新增</el-button>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="all_control" v-if=" this.$route.params.userId==3">
        <div class="all_control_input_button">
          <div class="Type_title">
            <span>FAB用户</span>
          </div>
          <div class="type_selection">
            <div>
              <span>关联类型</span>
            </div>
            <el-radio-group v-model="selectFAB">
              <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)"
                        :disabled="opt.id!=jinxuan">
                {{ opt.value }}
              </el-radio>
            </el-radio-group>
          </div>
          <div>
            <div class="title_input_button">
              <div class="titles">
                <span>关联企业</span>
              </div>
              <div class="all_input">
                <el-select v-model="FABcompanChoice" filterable placeholder="请选择" style="width: 200px" value-key="id"
                           clearable @change="change('b', FABcompanChoice)">
                  <el-option
                      v-for="item in FABcompanyTable"
                      :key="item.id"
                      :label="item.enterprise"
                      :value="{id:item.id, companyName:item.enterprise}"
                  >
                  </el-option>
                </el-select>

              </div>
              <div>
                <el-button @click="add_companyTable=2">新增</el-button>
              </div>
            </div>

          </div>
          <div>
            <div class="title_input_button">
              <div class="titles">
                <span>关联人员</span>
              </div>
              <div class="all_input">
                <el-select v-model="FABstaff_name_select" filterable placeholder="请选择" style="width: 200px">
                  <el-option
                      v-for="item in FABcompanyStaffTable"
                      :key="item.value"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div>
                <el-button @click="Pan_add_FABstaff">新增</el-button>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="all_control" v-if="  this.$route.params.userId==3">

        <div class="all_control_input_button">
          <div class="Type_title">
            <span>OEM设备商</span>
          </div>
          <div class="type_selection">
            <div>
              <span>关联类型</span>
            </div>
            <el-radio-group v-model="selectOEM">
              <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)"
                        :disabled="opt.id!=jinxuan4">
                {{ opt.value }}
              </el-radio>
            </el-radio-group>
          </div>
          <div>
            <div class="title_input_button">
              <div class="titles">
                <span>关联企业</span>
              </div>
              <div class="all_input">
                <el-select v-model="OEMcompanyChoice" filterable placeholder="请选择" style="width: 200px" value-key="id"
                           clearable @change="change('c', OEMcompanyChoice)">
                  <el-option
                      v-for="item in OEMcompanyTable"
                      :key="item.id"
                      :label="item.enterprise"
                      :value="{id:item.id, companyName:item.enterprise}"
                  >
                  </el-option>
                </el-select>

              </div>
              <div>
                <el-button @click="add_companyTable=3">新增</el-button>
              </div>
            </div>

          </div>
          <div>
            <div class="title_input_button">
              <div class="titles">
                <span>关联人员</span>
              </div>
              <div class="all_input">
                <el-select v-model="OEMstaff_name_select" filterable placeholder="请选择" style="width: 200px">
                  <el-option
                      v-for="item in OEMcompanyStaffTable"
                      :key="item.value"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div>
                <el-button @click="Pan_add_OEMstaff">新增</el-button>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="all_control" v-if="  this.$route.params.userId==5">

        <div class="all_control_input_button">
          <div class="Type_title">
            <span>OEM设备商</span>
          </div>
          <div class="type_selection">
            <div>
              <span>关联类型</span>
            </div>
            <el-radio-group v-model="selectOEMs">
              <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)"
                        :disabled="opt.id!=jinxuan">
                {{ opt.value }}
              </el-radio>
            </el-radio-group>
          </div>
          <div>
            <div class="title_input_button">
              <div class="titles">
                <span>关联企业</span>
              </div>
              <div class="all_input">
                <el-select v-model="OEMcompanyChoice" filterable placeholder="请选择" style="width: 200px" value-key="id"
                           clearable @change="change('c', OEMcompanyChoice)">
                  <el-option
                      v-for="item in OEMcompanyTable"
                      :key="item.id"
                      :label="item.enterprise"
                      :value="{id:item.id, companyName:item.enterprise}"
                  >
                  </el-option>
                </el-select>

              </div>
              <div>
                <el-button @click="add_companyTable=3">新增</el-button>
              </div>
            </div>

          </div>
          <div>
            <div class="title_input_button">
              <div class="titles">
                <span>关联人员</span>
              </div>
              <div class="all_input">
                <el-select v-model="OEMstaff_name_select" filterable placeholder="请选择" style="width: 200px">
                  <el-option
                      v-for="item in OEMcompanyStaffTable"
                      :key="item.value"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div>
                <el-button @click="Pan_add_OEMstaff">新增</el-button>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="all_control" v-if="this.$route.params.userId==5">
        <div class="all_control_input_button">
          <div class="Type_title">
            <span>竞品关联信息</span>
          </div>
          <div class="type_selection">
            <div>
              <span>关联类型</span>
            </div>
            <div v-if="this.$route.params.userId!=5">
              <el-radio-group v-model="selectC">
                <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)"
                          :disabled="opt.id!=jinxuan2">
                  {{ opt.value }}
                </el-radio>
              </el-radio-group>
            </div>
            <div v-if="this.$route.params.userId==5">
              <el-radio-group v-model="selectC">
                <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)"
                          :disabled="opt.id!=jinxuan2">
                  {{ opt.value }}
                </el-radio>
              </el-radio-group>
            </div>
          </div>
          <div>
            <div class="title_input_button">
              <div class="titles">
                <span>关联企业</span>
              </div>
              <div class="all_input">
                <el-select v-model="companyChoice" filterable placeholder="请选择" style="width: 200px" value-key="id"
                           clearable @change="change('a', companyChoice)">
                  <el-option
                      v-for="item in companyTable"
                      :key="item.id"
                      :label="item.enterprise"
                      :value="{id:item.id, companyName:item.enterprise}"
                  >
                  </el-option>
                </el-select>
              </div>
              <div>
                <el-button @click="Pan_add_companyTable">新增</el-button>
              </div>
            </div>

          </div>
          <div>
            <div class="title_input_button">
              <div class="titles">
                <span>关联人员</span>
              </div>
              <div class="all_input">
                <el-select v-model="staff_name_select" filterable placeholder="请选择" style="width: 200px"
                >
                  <el-option
                      v-for="item in companyStaffTable"
                      :key="item.value"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div>
                <el-button @click="Pan_add_staff()">新增</el-button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="all_input_controls">
      <div class="all_controls">
        <div class="all_control_input_buttons">

          <div class="all_control_input_buttons_textar">
            <div class="left">
              <div class="Type_title">
                <span>竞品&设备&制程</span>
              </div>
              <div>
                <div class="title_input_button" v-show="this.$route.params.userId!=1">
                  <div class="titles">
                    <span>设备型号</span>
                  </div>
                  <div class="all_input">

                    <el-select v-model="deviceChoice" filterable placeholder="请选择" style="width: 200px" clearable
                               @change="change('d', companyChoice)">
                      <el-option
                          v-for="item in deviceTable"
                          :key="item.value"
                          :label="item.device_type"
                          :value="item.device_type">
                      </el-option>
                    </el-select>
                  </div>
                  <div>
                    <el-button @click="Pan_add_device_type">新增</el-button>
                  </div>
                </div>

              </div>
              <div>
                <div class="title_input_button">
                  <div class="titles">
                    <span>制程工艺</span>
                  </div>
                  <div class="all_input">

                    <el-select v-model="processChoice" filterable placeholder="请选择" style="width: 200px">
                      <el-option
                          v-for="item in processTable"
                          :key="item.value"
                          :label="item.process_technology"
                          :value="item.process_technology">
                      </el-option>
                    </el-select>
                  </div>
                  <div>
                    <el-button @click="Pan_add_process">新增</el-button>
                  </div>
                </div>
              </div>
              <div>
                <div class="title_input_button">
                  <div class="titles">
                    <span>竞品类别</span>
                  </div>
                  <div class="all_input">

                    <el-select v-model="categoryChoice" filterable placeholder="请选择" style="width: 200px">
                      <el-option
                          v-for="item in categoryTable"
                          :key="item.value"
                          :label="item.title"
                          :value="item.title">
                      </el-option>
                    </el-select>
                  </div>
                  <div>
                    <el-button @click="Pan_add_category">新增</el-button>
                    <el-button @click="Pan_add_category">新增</el-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="lefts">

              <div class="title_input_buttons">
                <div class="titles">
                  <span>竞品&设备情况</span>
                </div>
                <div class="all_input">
                  <el-input
                      style=""
                      type="textarea"
                      :rows="2"
                      placeholder="请输入内容"
                      v-model="textarea">
                  </el-input>
                </div>

              </div>
              <div class="title_input_buttons">
                <div class="titles">
                  <span>人员关系&活动</span>
                </div>
                <div class="all_input">
                  <el-input
                      type="textarea"
                      :rows="2"
                      placeholder="请输入内容"
                      v-model="textarea">
                  </el-input>
                </div>
              </div>
              <div class="Login_button">
                <el-upload
                    class="upload-demo"
                    action="http://hairong.zhongqinchina.com/api/up_files/upload"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    :before-upload="beforeAvatarUpload"
                    :on-success="urlChange"
                    multiple
                    :limit="1"
                    :on-exceed="handleExceed"
                    :file-list="fileList">
                  <el-button type="primary" style="width:390px;margin-bottom:10px">点击上传</el-button>
                </el-upload>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="button_update">
      <el-button type="primary" style="height: 56px; width: 390px" @click="updateAll"
      >点击提交
      </el-button
      >
    </div>
    <div class="add_info" v-if="add_staff_type===1">
      <div class="add_staff_info_titleAndInput">
        <span>企业</span>
        <el-input style="width: 200px" :value="companyChoice.companyName" :disabled="false"
                  :v-model="staff_companyChoice=companyChoice.id"></el-input>
      </div>
      <div class="add_staff_info_titleAndInput">
        <span>姓名</span>
        <el-input style="width: 200px" v-model="staff_Name"></el-input>
      </div>
      <div class="add_staff_info_titleAndInput">
        <span>手机号</span>
        <el-input style="width: 200px" v-model="staff_phone"></el-input>
      </div>
      <div class="add_staff_info_titleAndInput">
        <span>微信</span>
        <el-input style="width: 200px" v-model="staff_wechart"></el-input>
      </div>
      <div class="add_info_button">
        <el-button @click="addStaff">添加</el-button>
        <el-button @click="Pan_add_staff">返回</el-button>
      </div>
    </div>
    <div class="add_info" v-if="add_companyTable===1">
      <div class="add_staff_info_titleAndInput">
        <span>企业名称</span>
        <el-input style="width: 200px" v-model="add_company_name"></el-input>
      </div>
      <div class="add_staff_info_titleAndInput">
        <span>简称</span>
        <el-input style="width: 200px" v-model="add_company_abbreviation"></el-input>
      </div>
      <div class="add_info_button">
        <el-button @click="addcompany">添加</el-button>
        <el-button @click="Pan_add_companyTable">返回</el-button>
      </div>
    </div>
    <div class="add_info" v-if="add_staff_type===2">
      <div class="add_staff_info_titleAndInput">
        <span>企业</span>
        <el-input style="width: 200px" :value="FABcompanChoice.companyName" :disabled="false"
                  :v-model="staff_companyChoice=FABcompanChoice.id"></el-input>
      </div>
      <div class="add_staff_info_titleAndInput">
        <span>姓名</span>
        <el-input style="width: 200px" v-model="staff_Name"></el-input>
      </div>
      <div class="add_staff_info_titleAndInput">
        <span>手机号</span>
        <el-input style="width: 200px" v-model="staff_phone"></el-input>
      </div>
      <div class="add_staff_info_titleAndInput">
        <span>微信</span>
        <el-input style="width: 200px" v-model="staff_wechart"></el-input>
      </div>
      <div class="add_info_button">
        <el-button @click="addFABStaff">添加</el-button>
        <el-button @click="Pan_add_staff">返回</el-button>
      </div>
    </div>
    <div class="add_info" v-if="add_companyTable===2">
      <div class="add_staff_info_titleAndInput">
        <span>企业名称</span>
        <el-input style="width: 200px" v-model="add_company_name"></el-input>
      </div>
      <div class="add_staff_info_titleAndInput">
        <span>简称</span>
        <el-input style="width: 200px" v-model="add_company_abbreviation"></el-input>
      </div>
      <div class="add_info_button">
        <el-button @click="addFABcompany">添加</el-button>
        <el-button @click="Pan_add_companyTable">返回</el-button>
      </div>
    </div>
    <div class="add_info" v-if="add_staff_type===3">
      <div class="add_staff_info_titleAndInput">
        <span>企业</span>
        <el-input style="width: 200px" :value="OEMcompanyChoice.companyName" :disabled="false"
                  :v-model="staff_companyChoice=OEMcompanyChoice.id"></el-input>
      </div>
      <div class="add_staff_info_titleAndInput">
        <span>姓名</span>
        <el-input style="width: 200px" v-model="staff_Name"></el-input>
      </div>
      <div class="add_staff_info_titleAndInput">
        <span>手机号</span>
        <el-input style="width: 200px" v-model="staff_phone"></el-input>
      </div>
      <div class="add_staff_info_titleAndInput">
        <span>微信</span>
        <el-input style="width: 200px" v-model="staff_wechart"></el-input>
      </div>
      <div class="add_info_button">
        <el-button @click="addOEMStaff">添加</el-button>
        <el-button @click="Pan_add_staff">返回</el-button>
      </div>
    </div>
    <div class="add_info" v-if="add_companyTable===3">
      <div class="add_staff_info_titleAndInput">
        <span>企业名称</span>
        <el-input style="width: 200px" v-model="add_company_name"></el-input>
      </div>
      <div class="add_staff_info_titleAndInput">
        <span>简称</span>
        <el-input style="width: 200px" v-model="add_company_abbreviation"></el-input>
      </div>
      <div class="add_info_button">
        <el-button @click="addOEMcompany">添加</el-button>
        <el-button @click="Pan_add_companyTable">返回</el-button>
      </div>
    </div>
    <div class="add_info" v-if="add_device_type===1">
      <div class="add_staff_info_titleAndInput">
        <span>设备型号</span>
        <el-input style="width: 200px" v-model="add_device"></el-input>
      </div>
      <div class="add_info_button">
        <el-button @click="addDevice">添加</el-button>
        <el-button @click="Pan_add_device_type">返回</el-button>
      </div>
    </div>
    <div class="add_info" v-if="add_process===1">
      <div class="add_staff_info_titleAndInput">
        <span>制程工艺</span>
        <el-input style="width: 200px" v-model="add_process_input"></el-input>
      </div>
      <div class="add_info_button">
        <el-button @click="addProcess">添加</el-button>
        <el-button @click="Pan_add_process">返回</el-button>
      </div>
    </div>
    <div class="add_info" v-if="add_category===1">
      <div class="add_staff_info_titleAndInput">
        <span>竞品类别</span>
        <el-input style="width: 200px" v-model="add_category_input"></el-input>
      </div>
      <div class="add_info_button">
        <el-button @click="addCategory">添加</el-button>
        <el-button @click="Pan_add_companyTable">返回</el-button>
      </div>
    </div>

    <div class="Copyright_information">
      <span>Copyright © 胤舜密封EBD数据平台限内部使用 版权所有</span>
    </div>
  </div>
</template>

<script>
import {httpUrl} from "@/components/publics";

export default {
  name: "Main_menuComputer",
  data() {
    return {
      jinxuan2: 1,
      jinxuan3: 3,
      jinxuan4: 5,
      selectFAB: "",
      add_companyTable: 0,
      add_staff_type: 0,
      add_company_name: "",
      add_company_abbreviation: "",
      companyStaffTable: "",
      companyStaffChoice: "",
      jinxuan: "",//判断是否禁选和传过来的UserID进行比较
      selectC: "",//单选框值
      companyTable: {},//公司列表
      FABcompanyTable: {},//FAB公司列表
      companyChoice: {},//公司列表
      OEMcompanyTable: {},//OEM公司列表
      OEMcompanyChoice: {},//公司列表
      FABcompanChoice: {},//FAB公司选择
      selectTable: {},//单选框列表
      deviceTable: {},//设备列表
      deviceChoice: "",//设备选择
      processTable: {},//制程工艺列表
      processChoice: "",//制程工艺列表
      categoryTable: {},//制程工艺列表
      categoryChoice: "",//制程工艺列表
      user_leave: {},
      staff_Name: "",
      staff_phone: "",
      staff_wechart: "",
      staff_companyChoice: "",
      staff_name_select: "",
      FABstaff_name_select: "",
      OEMstaff_name_select: "",
      FABcompanyStaffTable: {},//FAB员工列表
      OEMcompanyStaffTable: {},//OEM员工列表
      add_device_type: 0,
      add_process: 0,
      add_category: 0,
      add_device: "",
      add_process_input: "",
      add_category_input: "",
      selectOEM:"",
      selectOEMs:"",
      urlImage:'',
      fileList:[],
    };
  },
  watch: {
    companyChoice(newName, oldName) {
      // console.log(newName.id,'这里看的是参数')
      this.selectcompanystaff(newName.id);
    },
    FABcompanChoice(newName, oldName) {
      // console.log(newName.id,'这里看的是参数')
      this.selectFABcompanystaff(newName.id);
    },
    OEMcompanyChoice(newName, oldName) {
      // console.log(newName.id,'这里看的是参数')
      this.selectOEMcompanystaff(newName.id);
    },

  },
  mounted() {
    this.selectName();
    this.selectcompany();
    this.selectFABcompany();
    this.selectOEMcompany();
    this.selectdevice();
    this.selectprocess();
    this.selectCategory();
    this.getUser();
    this.jinxuan = this.$route.params.userId;
    console.log(this.$route.params)
  },

  methods: {

    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {

    },
    urlChange(e) {
      console.log('url', e);
      if (e.code == 200) {
        this.urlImage = e.data.img
      }
    },
    beforeAvatarUpload(file) {
      console.log('file', file);
      // accept=".jpg,.jpeg,.png,.pdf,.JPG,.JPEG,.PDF,DOC"

      let fileName = file.name.substring(file.name.lastIndexOf('.') + 1);
      var arr = ['png', 'jpeg', 'jpg', 'pdf', 'doc', 'PNG', 'JPEG', 'JPG', 'PDF', 'DOC'];
      let status = arr.findIndex((value, key) => {
        return fileName == value
      });
      console.log('fileName', fileName, status);
      if (status == -1) {
        this.$message('上传文件只能是 png、jpeg、jpg、pdf、doc格式!');
        return false
      }
      // if(!extension && !extension2) {
      //   this.$message({
      //     message: '上传文件只能是 xls、xlsx格式!',
      //     type: 'warning'
      //   });
      // }
    },
    //新增公司
    addcompany() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/enterpriseAdd",
              this.$qs.stringify({
                enterprise: this.add_company_name,
                // association_type
                abbreviation: this.add_company_abbreviation,

              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_companyTable = 0;
              this.selectcompany();
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    //新增公司
    addFABcompany() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/enterpriseEndAdd",
              this.$qs.stringify({
                enterprise: this.add_company_name,
                // association_type
                abbreviation: this.add_company_abbreviation,

              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_companyTable = 0;
              this.selectFABcompany();
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    //新增公司
    addOEMcompany() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/equipmentSupplierAdd",
              this.$qs.stringify({
                enterprise: this.add_company_name,
                // association_type
                abbreviation: this.add_company_abbreviation,

              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_companyTable = 0;
              this.selectOEMcompany();
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    //新增竞争公司销售人员
    addStaff() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/relatedPersonnelAdd",
              this.$qs.stringify({
                enterprise_id: this.staff_companyChoice,
                // association_type
                name: this.staff_Name,
                phone: this.staff_phone,
                wechat: this.staff_wechart,
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_staff_type = 0;

            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    //新增竞争公司销售人员
    addFABStaff() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/relatedPersonnelEndAdd",
              this.$qs.stringify({
                enterprise_end_id: this.staff_companyChoice,
                // association_type
                name: this.staff_Name,
                phone: this.staff_phone,
                wechat: this.staff_wechart,
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_staff_type = 0;
              this.selectFABcompany()
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    //新增设备型号
    addDevice() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/deviceTypeAdd",
              this.$qs.stringify({
                device_type: this.add_device
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_device_type = 0;
              this.selectdevice()
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    //新增制程工艺
    addProcess() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/processTechnologyAdd",
              this.$qs.stringify({
                process_technology: this.add_process_input
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_process = 0;
              this.selectprocess()
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));

    },
    //新增竞品类别
    addCategory() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/categoryAdd",
              this.$qs.stringify({
                title: this.add_category_input
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_category = 0;
              this.selectCategory()
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));

    },
    //新增OEM销售人员
    addOEMStaff() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/relatedPersonnelSupplierAdd",
              this.$qs.stringify({
                enterprise_supplier_id: this.staff_companyChoice,
                // association_type
                name: this.staff_Name,
                phone: this.staff_phone,
                wechat: this.staff_wechart,
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_staff_type = 0;
              this.selectFABcompany()
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    changeSelect() {
      this.$forceUpdate()
    },
    //判断是否打开新增竞争公司销售人员弹窗
    Pan_add_staff() {
      if (this.add_staff_type == 0) {
        if (Object.keys(this.companyChoice).length != "") {
          this.add_staff_type = 1
        } else {
          this.$message("请填写竞争公司后在进行添加")
        }

      } else {
        this.add_staff_type = 0
      }
    },
    //判断是否打开新增FAB销售人员弹窗
    Pan_add_FABstaff() {
      if (this.add_staff_type == 0) {
        if (Object.keys(this.FABcompanChoice).length != "") {
          this.add_staff_type = 2
        } else {
          this.$message("请填写竞争公司后在进行添加")
        }

      } else {
        this.add_staff_type = 0
      }
    },
    //判断是否新增竞争公司
    Pan_add_companyTable() {
      if (this.add_companyTable == 0) {
        this.add_companyTable = 1
      } else {
        this.add_companyTable = 0
      }
    },
    Pan_add_device_type() {
      if (this.add_device_type == 0) {
        this.add_device_type = 1
      } else {
        this.add_device_type = 0
      }
    },
    Pan_add_category() {
      if (this.add_category == 0) {
        this.add_category = 1
      } else {
        this.add_category = 0
      }
    },
    Pan_add_process() {
      if (this.add_process == 0) {
        this.add_process = 1
      } else {
        this.add_process = 0
      }
    },
    //判断是否打开新增OEM销售人员弹窗
    Pan_add_OEMstaff() {
      if (this.add_staff_type == 0) {
        if (Object.keys(this.OEMcompanyChoice).length != "") {
          this.add_staff_type = 3
        } else {
          this.$message("请填写竞争公司后在进行添加")
        }

      } else {
        this.add_staff_type = 0
      }
    },
    //判断是否新增竞争公司
    change(params, val) {
      console.log(params, '这里测试的是parames');
      if (params == "a" && val != "") {
        this.staff_name_select = "";
      }
      if (params == "b" && val != "") {
        this.FABstaff_name_select = "";
      }
      if (params == "c" && val != "") {
        this.OEMstaff_name_select = "";
      }
    },
    //单选框赋值
    selectName() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/association `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.selectTable = response.data.data;
              // console.log(selectTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询公司列表
    selectcompany() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/enterprise `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.companyTable = response.data.data;
              console.log(companyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询FAB列表
    selectFABcompany() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/enterprise_end`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.FABcompanyTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询OEM列表
    selectOEMcompany() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/equipment_supplier`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.OEMcompanyTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询设备列表
    selectdevice() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/device_type`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.deviceTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询制程工艺列表
    selectprocess() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/process_technology`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.processTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //竞品类别列表
    selectCategory() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/category`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.categoryTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询竞争对手销售人员
    selectcompanystaff(newNames) {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/related_personnel?enterprise_id=${newNames} `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.companyStaffTable = response.data.data;
              console.log(companyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    selectFABcompanystaff(newNames) {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/related_personnel_end?enterprise_end_id=${newNames} `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.FABcompanyStaffTable = response.data.data;
              console.log(companyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    selectOEMcompanystaff(newNames) {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/related_personnel_supplier?enterprise_supplier_id=${newNames} `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.OEMcompanyStaffTable = response.data.data;
              console.log(companyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询制程工艺
    updateAll() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/competitiveProductAdd",
              this.$qs.stringify({
                user_id: this.user_leave.id,
                quadrant_id : this.$route.params.userId,
                enterprise_id : this.companyChoice.id,
                enterprise_user_id : this.staff_name_select,
                enterprise_type:this.selectC,
                enterprise_end_id : this.FABcompanChoice.id,
                enterprise_end_user_id : this.FABstaff_name_select,
                enterprise_end_type : this.selectFAB,
                equipment_supplier_id : this.OEMcompanyChoice.id,
                equipment_supplier_user_id: this.OEMstaff_name_select,
                equipment_supplier_type : this.selectOEMs,
                device_type:"",
                process_technology:"",
                category:"",
                equipment_condition:"",
                personnel_relations:"",
    })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_staff_type = 0;
              this.selectFABcompany()
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    getUser() {
      this.user_leave = JSON.parse(sessionStorage.getItem("user"));
      console.log(this.user_leave);
    },
    // dengji() {
    //   this.$router.push("/second_menuComputer_PriceAndInventory");
    // },
    // PushJiaGe() {
    //   this.$router.push("/second_menuComputer_PriceAndInventory");
    // },
    // PushChanPin() {
    //   this.$router.push("/ICChanPinXinXi");
    // },
    // ShiChangXinXi() {
    //   this.$router.push("/TableInput");
    // },
    // PushRenWu() {
    //   this.$router.push("/missionComputer");
    // },
    // PushCaiWu() {
    //   this.$router.push("/FinanceComputer");
    // },
  },
};
</script>

<style>
</style>
<style scoped>
.add_info {
  width: 25%;
  height: 35%;
  background: #42b983;
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  border-radius: 6px;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.add_staff_info_titleAndInput {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  text-align: right;

}

.add_staff_info_titleAndInput span {
  width: 14%;
  text-align: left;
}

.left {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 25%;
}

.lefts {
  display: flex;
  flex-direction: column;

  width: 25%;
}

.all_control_input_buttons_textar {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  height: 70%;
}

.all_input_control {
  height: 38%;
  display: flex;
  justify-content: space-around;
}

.all_input_controls {
  height: 62%;
  display: flex;
  justify-content: space-around;
}

.all_control_input_button {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.all_control_input_buttons {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.Type_title {
  text-align: left;
}

.type_selection {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_control {

  display: flex;
  justify-content: center;
  width: 50%;
  height: 90%;
}

.title_input_buttons .titles {
  width: 100%;
  text-align: left;
  margin-bottom: 10px;
}

.title_input_buttons {

  margin-bottom: 10px;
}

.all_controls {
  background: #8EC31F;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 90%;
}

.title_input_button {
  align-items: center;
  display: flex;
  flex-direction: row;
  /*width: 50%;*/
  justify-content: space-between;
}

.input_button {
  display: flex;
  flex-direction: row;
  width: 100%;
  /*justify-content: space-between;*/
}

.all_input {
  display: flex;
  flex-direction: column;
}

.alone_span_title {
  color: #ffffff;
  font-size: 24px;
}

.alone_span_user {
  color: #ffffff;
  font-size: 20px;
}

.Competitive_span {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.CompetitiveChoice {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: #18a575;
  width: 40%;
}

.CompetitiveChoice_button_alone {
  background: #42b983;
  height: 80%;
  width: 90%;
  justify-content: space-around;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 4px;
}

.CompetitiveChoice_button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: olivedrab;
  width: 270pt;
  height: 102pt;

  border-radius: 4px;
}

.row_span {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
}

.all_part {
  background-image: url("../assets/Main_menu_img/BG.png");
  background-position: bottom left;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  min-height: 925px;
  min-width: 1920px;
}

.head {
  background-image: url("../assets/Main_menu_img/menu_title_bg.png");
  display: flex;
  justify-content: center;
}

.main_button {
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%;
  height: 70%;
}

.JiaGeKuCun {
  justify-content: space-around;
  display: flex;
  flex-direction: row;
  width: 80%;
}

.Logo {
  margin-top: 30px;
}

.button_update {
  height: 150px;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.button {
  flex-direction: column;
  justify-content: center;
  display: flex;
  align-items: center;
  height: 200px;
  width: 200px;
  background-color: #18a575;
  border-radius: 6px;
}

.button span {
  font-weight: 600;
  color: #ffffff;
  font-size: 20px;
  margin-top: 30px;
}

.Copyright_information {
  margin-bottom: 15px;
}
</style>
